import { render, staticRenderFns } from "./media-instagram.vue?vue&type=template&id=7cfeccf6&scoped=true&"
import script from "./media-instagram.vue?vue&type=script&lang=js&"
export * from "./media-instagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfeccf6",
  null
  
)

export default component.exports